"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.callDurationsTranslations = {
    "en": {
        average: "Average",
        maximum: "Maximum",
        callDuration: "Call Duration",
        totalCallTime: "Total Call Time",
        queueTime: "Queue Time",
        talkTime: "Talk Time",
    },
    "de": {
        average: "Durchschnittlich",
        callDuration: "Anrufdauer",
        talkTime: "Gesprächszeit",
        totalCallTime: "Gesamtanrufzeit",
        queueTime: "Wartezeit",
        maximum: "Maximal",
    },
    "nl": {
        average: "Gemiddeld",
        callDuration: "Duur van de oproep",
        talkTime: "Gesprekstijd",
        totalCallTime: "Totale oproepduur",
        queueTime: "Wachtrijtijd",
        maximum: "Maximaal",
    },
    "it": {
        average: "Medio",
        callDuration: "Durata della chiamata",
        talkTime: "Tempo di conversazione",
        totalCallTime: "Tempo di chiamata totale",
        queueTime: "Tempo in coda",
        maximum: "Massimo",
    },
    "fr": {
        average: "Moyenne",
        callDuration: "Durée de l'appel",
        talkTime: "Temps de parole",
        totalCallTime: "Durée totale de l'appel",
        queueTime: "Temps en file d'attente",
        maximum: "Maximum",
    },
    "es": {
        average: "Promedio",
        callDuration: "Duración de la llamada",
        talkTime: "Tiempo de conversación",
        totalCallTime: "Tiempo total de llamada",
        queueTime: "Tiempo de espera en la cola",
        maximum: "Máximo",
    },
    "ja": {
        average: "平均",
        callDuration: "通話時間",
        talkTime: "対話時間",
        totalCallTime: "合計通話時間",
        queueTime: "キュー時間",
        maximum: "最長",
    },
    "en-GB": {
        average: "Average",
        callDuration: "Call Duration",
        talkTime: "Talk Time",
        totalCallTime: "Total Call Time",
        queueTime: "Queue Time",
        maximum: "Maximum",
    },
    "ru": {
        average: "Среднее",
        maximum: "Максимальное",
        callDuration: "Длительность Звонка",
        totalCallTime: "Общее Время Звонка",
        queueTime: "Время Ожидания",
        talkTime: "Время Разговора",
    },
};
